<script lang="ts">
	import Modal, { bind } from 'svelte-simple-modal';
	import { writable } from 'svelte/store';
	import NewsMessage from '../../../../shared/models/News/NewsMessage';
	import NewsContent from './NewsContent.svelte';

	let showNotifications = false;
	const modal = writable(null);

	let [dataNews, loadingNews, errorNews] = NewsMessage.getMyMessages();
</script>

<Modal show="{$modal}" on:close="{() => ([dataNews, loadingNews, errorNews] = NewsMessage.getMyMessages())}" />
<div class="relative">
	<!-- Red dot -->
	{#if $dataNews?.length > 0 && $dataNews.some((element) => element.attribute?.isRead === false)}
		<div class="animate-ping absolute right-0 p-1 bg-red-400 rounded-full"></div>
		<div class="absolute right-0 p-1 bg-red-400 border rounded-full"></div>
	{/if}
	<button
		on:focus="{() => {
			showNotifications = true;
			[dataNews, loadingNews, errorNews] = NewsMessage.getMyMessages();
		}}"
		on:blur="{() => (showNotifications = false)}"
		class="bg-gray-50 ring-mobilityPlatform-green-active hover:bg-white focus:outline-none focus:ring-1 p-2 transition-all duration-200 rounded-full"
	>
		<svg class="w-6 h-6 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
			></path>
		</svg>
	</button>

	<!-- Dropdown card -->
	<div
		class="absolute w-96 max-w-md transition-all duration-200 {showNotifications
			? ''
			: 'invisible'} min-w-max -translate-x-3/4 transform rounded-md bg-white shadow-lg"
	>
		<!--
            <div class="p-4 font-medium border-b">
                <span class="text-gray-800">Notification</span>
            </div>
        -->
		{#if $dataNews?.length > 0}
			<ul
				class="my-2 mr-10 flex flex-col space-y-1 overflow-hidden overflow-y-auto p-2 {$dataNews && $dataNews.length > 10
					? 'h-80'
					: 'h-auto'}"
			>
				{#each $dataNews as row}
					<li>
						<span
							role="button"
							tabindex="0"
							on:keydown="{() => modal.set(bind(NewsContent, { data: row }))}"
							on:click="{() => modal.set(bind(NewsContent, { data: row }))}"
							class="block cursor-pointer rounded-md px-2 py-1 transition {row.attribute?.isRead
								? 'bg-gray-50 hover:bg-gray-100'
								: 'bg-mobilityPlatform-lightgreen hover:bg-mobilityPlatform-green-hover'}">{row.title}</span
						>
					</li>
				{/each}
			</ul>
			<!--
            {#if $dataNews.length < 5}
                <div class="text-mobilityPlatform-green flex items-center justify-center p-4 underline border-t">
                    <span class="cursor-pointer" on:click={() => [dataNews, loadingNews, errorNews] = NewsMessage.getMyMessages()}>Guarda tutte</span>
                </div>
            {/if}
            -->
		{:else}
			<div class="flex items-center justify-center p-4 border-t">
				<span>Nessuna notifica</span>
			</div>
		{/if}
	</div>
</div>
